import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class MiddlewareService {

  constructor() { }

  private actionSource = new Subject<void>();
  action$ = this.actionSource.asObservable();

  private actionSourceReview = new Subject<void>();
  actionReview$ = this.actionSourceReview.asObservable();
  
  triggerRefreshAlertAction() {
    this.actionSource.next();
  }

  triggerShowReviewAction() {
    this.actionSourceReview.next();
  }
}
